import script from "./AuctionItemEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./AuctionItemEdit.vue?vue&type=script&setup=true&lang=js"

import "./AuctionItemEdit.vue?vue&type=style&index=0&id=12ab3142&lang=css"

const __exports__ = script;

export default __exports__